import styled from 'styled-components';
import { AppStyledProps } from '../../../../../../../types';

type T = AppStyledProps;

export const BodyStyled = styled.div<T>`
  padding: 1em 0;

  img {
    max-height: 70vh;
    width: 100%;
  }

  p {
    overflow-wrap: anywhere;
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
    img {
      max-height: 60vh;
    }
  `}
`;
